<!--
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2021-11-25 13:05:57
 * @LastEditTime: 2022-05-23 18:11:18
 * @LastEditors: 赵大壮
-->
<template>
  <router-view v-if="isRouterAlive"></router-view>
</template>


<script>
export default {
  name: "app",
  components: {},
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {},
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
};
</script>
<style>
</style>
